export const DU_DOAN_COLORS = {
  sidebarBg: "#FFFFFF",
  leaderboardListBg: "#F1F2F4",
  leaderboardItemBg: "#FFFFFF",
  tabActive: "#E12424",
  tabInactiveBorder: "#D9D9D9",
  tabInactiveBg: "#F1F2F4",
  cardBorder: "#E5E5E5",
  avatarBlue: "#0A68FF",
};

export const CDN_URL = "https://cdn.keobongvip.digital";
